module.exports = __webpack_public_path__ + "static/img/74060F_1_R_20190831 (2)_LC.6ac918f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/74060F_1_R_20190831 (2)_LC.png
// module id = 826b
// module chunks = 0